import { ProgressCellData, ProgressStatus } from '../cell-renderers';

export function progressCellDataComparator(a?: ProgressCellData, b?: ProgressCellData): number {
	return mapToComparableProgressStatus(a?.status) - mapToComparableProgressStatus(b?.status);
}

function mapToComparableProgressStatus(value?: ProgressStatus): number {
	switch (value) {
		case ProgressStatus.Error:
			return 0;
		case ProgressStatus.InProgress:
			return 1;
		case ProgressStatus.Success:
			return 2;
		default:
			return Infinity;
	}
}
